export interface ChatToolCall {
  tool: string;
  is_error: boolean;
  summary?: string | null;
}

export interface ChatDatasetArtifact {
  dataset_id?: string | null;
  tool: string;
  meta?: Record<string, unknown> | null;
  preview_rows: Record<string, unknown>[];
  columns: string[];
}

export interface ChatChartArtifact {
  tool: string;
  chart_spec: {
    chart_type?: string;
    title?: string;
    x?: string;
    y?: string;
    series?: string;
    points?: Array<Record<string, unknown>>;
  };
}

export interface ChatJobArtifact {
  tool: string;
  job_id: string;
  status?: string | null;
  progress_pct?: number | null;
  template_id?: string | null;
  format?: string | null;
  download_url?: string | null;
  error?: string | null;
  file_name?: string | null;
  report_id?: string | null;
}

export interface ChatFileArtifact {
  tool: string;
  report_id?: string | null;
  download_url?: string | null;
  file_name?: string | null;
  format?: string | null;
  content_type?: string | null;
  size_bytes?: number | null;
}

export interface ChatErrorArtifact {
  tool: string;
  code?: string | null;
  user_message_ru?: string | null;
  user_message_uz?: string | null;
  message?: string | null;
}

export interface ChatTurnArtifacts {
  datasets: ChatDatasetArtifact[];
  charts: ChatChartArtifact[];
  jobs: ChatJobArtifact[];
  files: ChatFileArtifact[];
  errors: ChatErrorArtifact[];
}

export interface ChatSessionContext {
  user_id: string;
  role?: string | null;
  allowed_geo_ids: string[];
  locale?: string | null;
  max_tool_rounds: number;
}

export interface ChatHttpResponse {
  session_id: string;
  correlation_id: string;
  reply: string;
  rounds: number;
  tool_calls: ChatToolCall[];
  artifacts?: ChatTurnArtifacts;
  session_context?: ChatSessionContext | null;
  error?: string | null;
}

export interface DataConstraints {
  weather_available_from?: string;
  crop_available_from?: string;
  vegetation_index_available_from?: string;
  sentinel_cadence_days?: number;
  timezone?: string;
  max_rows_per_query?: number;
  unavailable_domains?: string[];
}

export function newAnalyticsId(): string {
  const cryptoObj = globalThis.crypto as Crypto | undefined;
  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return cryptoObj.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export interface AnalyticsChatMessage {
  id: string;
  role: 'user' | 'assistant';
  text: string;
  time: Date;
  artifacts?: ChatTurnArtifacts;
  tool_calls?: ChatToolCall[];
  rounds?: number;
  session_id?: string;
  correlation_id?: string;
  error?: string | null;
}

export interface StoredChatSession {
  id: string;
  title: string;
  updatedAt: string;
  starred: boolean;
}

export const emptyArtifacts = (): ChatTurnArtifacts => ({
  datasets: [],
  charts: [],
  jobs: [],
  files: [],
  errors: []
});
